/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DeptDialogController', DeptDialogController);

    DeptDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Dept', 'Profile', 'Payment', 'Booking', 'Activities', 'Project', 'DinghyEvent'];

    function DeptDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Dept, Profile, Payment, Booking, Activities, Project, DinghyEvent) {
        var vm = this;

        vm.dept = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.profiles = Profile.query();
        vm.payments = Payment.query();
        vm.bookings = Booking.query();
        vm.activities = Activities.query();
        vm.projects = Project.query();
        vm.dinghyevents = DinghyEvent.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dept.id !== null) {
                Dept.update(vm.dept, onSaveSuccess, onSaveError);
            } else {
                Dept.save(vm.dept, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:deptUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
